<template>
<div class="page-container">
  <page-header></page-header>
  <div class="dashboard-container">
    <div class="page-card">
      <div class="page-card-header">
        <span>{{ $route.meta.title }}</span>
        <div class="card-operation"></div>
      </div>
      <div class="page-card-body page-wrap-960">
        <el-form :model="adminModel" :rules="adminRules" ref="formRef" label-width="120px" v-loading="form_loading">
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="adminModel.realname"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="adminModel.username" :disabled="id !== null"></el-input>
          </el-form-item>
          <el-form-item prop="password" :rules="[{required:id<1, message: '请输入密码', trigger: 'blur'}]">
            <template slot="label">
              密码
              <span>
              <el-tooltip class="item" effect="dark" content="为空则不更新密码" placement="top">
                <i class="fa fa-question-circle"></i>
              </el-tooltip>
            </span>
            </template>
            <el-input v-model="adminModel.password"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="adminModel.mobile" type="number"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="adminModel.email"></el-input>
          </el-form-item>
          <el-form-item label="是否激活" prop="is_active">
            <el-checkbox v-model="adminModel.is_active"></el-checkbox>
          </el-form-item>
          <el-form-item label="汽车权限" prop="has_car_permission">
            <el-checkbox v-model="adminModel.has_car_permission"></el-checkbox>
          </el-form-item>
          <el-form-item label="巴士权限" prop="has_bus_permission">
            <el-checkbox v-model="adminModel.has_bus_permission"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitClose">取消</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import PageHeader from "@/components/PageHeader"
import {adminInfo, adminStore} from '@/api/auth'
import {patterns, messages as patternMessages} from "@/function/patterns"

export default {
  name: "Admin",
  components: {
    PageHeader,
  },
  data() {
    return {
      form_loading: false,
      id: null,
      adminModel: {
        realname: '',
        username: '',
        password: '',
        is_active: true,
        roles: [],
        mobile: '',
        email: '',
        is_supper_admin: false,
        has_car_permission: true,
        has_bus_permission: true,
      },
      adminRules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 2, message: '至少2个字符', trigger: 'blur'}
        ],
        realname: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        mobile: [
          {pattern: patterns.mobile, message: patternMessages.mobile, trigger: 'blur'},
        ],
        email: [
          {pattern: patterns.email, message: patternMessages.email, trigger: 'blur'},
        ],
      },
    }
  },
  created() {

  },
  mounted() {
    this.id = this.$route.params.id || null
    if (this.id) {
      this.getAdmin()
    } else {
      this.adminRules.password.push({required: true, message: '请填写密码', trigger: 'blur'})
    }
  },
  methods: {
    getAdmin() {
      let that = this
      that.form_loading = true
      adminInfo(that.id).then(res => {
        that.form_loading = false
        that.adminModel = {
          id: res.id,
          realname: res.realname || '',
          username: res.username,
          mobile: res.mobile || '',
          email: res.email || '',
          password: '',
          roles: res.roles,
          is_active: res.is_active,
          is_supper_admin: res.is_supper_admin || false,
          has_car_permission: res.has_car_permission || false,
          has_bus_permission: res.has_bus_permission || false,
        }
      }).catch(() => {
        that.form_loading = false
      })
    },
    submitClose() {
      this.$router.go(-1)
    },
    submit() {
      let that = this
      that.$refs.formRef.validate((valid) => {
        if (!valid) return false
        that.form_loading = true
        adminStore(that.adminModel).then(() => {
          that.form_loading = false
          that.$message.success('提交成功')
          setTimeout(function () {
            that.$router.go(-1)
          }, 2000)
        }).catch(() => {
          that.form_loading = false
        })
      })
    },
  },
}
</script>

<style>

</style>
